import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useGlobalContext } from '../../../../../utils/Context'
import { getTrail } from '../../../../../utils/WeightDiscrepancyApi'
import FormLoader from '../../../../../components/loader/FormLoader'
import Pagination from '../../../../../components/pagination/Pagination'

function DiscrepancyTrail() {
  const { notify } = useGlobalContext()
  const [trails, setTrails] = useState<any>({ trails: [], pagination: {} })
  const [loading, setLoading] = useState(true)

  function fetchTrail(page: number, limit: number) {
    setLoading(true)
    getTrail(page, limit)
      .then((result: any) => {
        if (result.status === 200) {
          setTrails(result.data)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  useEffect(() => { fetchTrail(1, 10) }, [])

  const fmt = (n: number) => `₦${n.toLocaleString()}`

  const typeInfo = (type: string): { icon: string; cls: string } => {
    switch (type) {
      case 'automatic':      return { icon: 'mdi:lightning-bolt',    cls: 'automatic'      }
      case 'manual':         return { icon: 'mdi:pencil-outline',    cls: 'manual'         }
      case 'payment-credit': return { icon: 'mdi:credit-card-outline', cls: 'payment-credit' }
      case 'payment-wallet': return { icon: 'ion:wallet-outline',    cls: 'payment-wallet' }
      default:               return { icon: 'mdi:circle-outline',    cls: ''               }
    }
  }

  return (
    <div>
      {loading ? (
        <FormLoader position='center' />
      ) : trails.trails.length > 0 ? (
        <>
          {/* ── Mobile cards ─────────────────────────────────────────── */}
          <div className='wd-mobile-cards'>
            {trails.trails.map((item: any) => {
              const t = typeInfo(item.type)
              const isDebit = item.amount > 0
              return (
                <div className='wd-mobile-card' key={item._id}>
                  <div className='wd-mc-top'>
                    <span className={`wd-type-badge ${t.cls}`}>
                      <Icon icon={t.icon} width='12' />
                      {item.type}
                    </span>
                    <p style={{ fontSize: '0.78rem', color: '#6b7280' }}>
                      {new Date(item.createdAt).toLocaleString()}
                    </p>
                  </div>

                  <div className='wd-mc-row'>
                    <h4>Description</h4>
                    <p>{item.description}</p>
                  </div>
                  <div className='wd-mc-row'>
                    <h4>Tracking ID</h4>
                    <p className='wd-td-mono'>{item.trackingId || '—'}</p>
                  </div>
                  <div className='wd-mc-row'>
                    <h4>Amount</h4>
                    <p className={isDebit ? 'wd-td-error' : 'wd-td-success'}>
                      {isDebit ? '+' : ''}{fmt(item.amount)}
                    </p>
                  </div>
                  <div className='wd-mc-row'>
                    <h4>Balance Before</h4>
                    <p>{fmt(item.amountBefore)}</p>
                  </div>
                  <div className='wd-mc-row'>
                    <h4>Balance After</h4>
                    <p><strong>{fmt(item.amountAfter)}</strong></p>
                  </div>
                </div>
              )
            })}
          </div>

          {/* ── Desktop table ─────────────────────────────────────────── */}
          <div className='wd-desktop-table'>
            <div className='wd-table-card'>
              <table className='wd-table'>
                <thead>
                  <tr>
                    {['#', 'Date', 'Description', 'Tracking ID', 'Type', 'Amount', 'Bal. Before', 'Bal. After'].map(h => (
                      <th key={h}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {trails.trails.map((item: any, i: number) => {
                    const t = typeInfo(item.type)
                    const isDebit = item.amount > 0
                    return (
                      <tr key={item._id}>
                        <td className='wd-td-num'>{i + 1}</td>
                        <td className='wd-td-muted wd-td-nowrap'>
                          {new Date(item.createdAt).toLocaleString()}
                        </td>
                        <td>{item.description}</td>
                        <td className='wd-td-mono'>{item.trackingId || '—'}</td>
                        <td>
                          <span className={`wd-type-badge ${t.cls}`}>
                            <Icon icon={t.icon} width='12' />
                            {item.type}
                          </span>
                        </td>
                        <td className={isDebit ? 'wd-td-error' : 'wd-td-success'}>
                          {isDebit ? '+' : ''}{fmt(item.amount)}
                        </td>
                        <td className='wd-td-nowrap'>{fmt(item.amountBefore)}</td>
                        <td className='wd-td-bold wd-td-nowrap'>{fmt(item.amountAfter)}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination
            currentPage={trails.pagination.page}
            totalCount={trails.pagination.pages}
            pageSize={trails.pagination.limit}
            onPageChange={(page: number, pageSize: number) => fetchTrail(page, pageSize)}
          />
        </>
      ) : (
        <div className='empty flex justify-center'>
          <div className='empty-cover'>
            <Icon icon='mdi:history' />
            <h1>No History To Show</h1>
            <p>Transaction history will appear here.</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default DiscrepancyTrail
